

































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import { ApiData } from "@/lib/apiData";
import AbpBase from "@/lib/abpbase";
import _ from "lodash";
import AppConsts from "@/lib/appconst";
import { generateAndDownloadBarcodeInPDF } from "@/lib/generateBarcode";

@Component
export default class PdfBarcodeDocument extends AbpBase {
  @Prop({ type: Object, default: new ApiData() }) value: ApiData;
  generating: boolean = false;
  pdfDocument: any;
  get store() {
    return this.$store.state.caseLabel;
  }
  get paperSizeDicInPointUnitPT() {
    var ret = AppConsts.paperSizeDicInPointUnitPT;
    switch (this.value.objectType) {
      case "collectionCode":
        ret = AppConsts.collectionCodePaperSizeDicInPointUnitPT;
        break;
      case "caseLabel":
        ret = AppConsts.paperSizeDicInPointUnitPT;
        break;
      default:
        break;
    }
    return ret;
  }
  pageSizeType: string = this.paperSizeDicInPointUnitPT[0].name;

  get sizeType() {
    let _sizeType = _.find(this.paperSizeDicInPointUnitPT, [
      "name",
      this.pageSizeType,
    ]);
    return _sizeType;
  }
  get pageHeight() {
    return _.result(this.sizeType, "height") || 0;
  }
  get pageRealHeight() {
    return _.result(this.sizeType, "realHeight") || 0;
  }
  get pageWidth() {
    return _.result(this.sizeType, "width") || 0;
  }
  get pageType() {
    return _.result(this.sizeType, "name");
  }
  get itemsPerPage() {
    return _.result(this.sizeType, "itemsPerPage");
  }
  get isGenerating() {
    return this.generating;
  }

  get qty() {
    return _.isNil(this.value) ||
      _.isNil(this.value.pages) ||
      this.value.pages.length <= 0
      ? 0
      : this.value.pages.length;
  }
  get paperSizeDicInPointUnit() {
    var items = _.map(this.paperSizeDicInPointUnitPT, "name");
    return items;
  }

  generatePDF = async () => {
    if (_.isNil(this.value) || _.isNil(this.value.pages)) {
      return;
    }
    if (this.value.objectType === "caseLabel") {
      await this.$store.dispatch({
        type: "caseLabel/print",
        data: { codes: this.value.pages },
      });
    }

    this.generating = true;
    generateAndDownloadBarcodeInPDF(
      this.value.pages,
      this.pageWidth,
      this.pageHeight,
      this.pageRealHeight,
      this.pageType,
      this.itemsPerPage
    );
    this.generating = false;

    let parent;
    switch (this.value.pagesTitle) {
      case "printer":
        parent = this.$parent.$parent;
        parent.$emit("download-file-printer");
        break;
      case "create":
        parent = this.$parent;
        parent.$emit("on-cancel");
        break;
      default:
        parent = this.$parent.$parent;
        parent.$emit("download-file-printer");
        break;
    }
  };

  onHandleCancel = () => {
    let parent;
    switch (this.value.pagesTitle) {
      case "printer":
        parent = this.$parent.$parent;
        parent.$emit("cancel-popup-print");
        break;
      case "create":
        parent = this.$parent;
        parent.$emit("on-cancel");
        break;
      default:
        parent = this.$parent.$parent;
        parent.$emit("cancel-popup-print");
        break;
    }
  };
  onChangeSizeType = (value: any) => {
    this.pageSizeType = value;
  };
}
